import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@lichtblick/photon/atoms/text/text';
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import styles from './hotline-modal-content.module.css';
export const HOTLINE_MODAL_TITLE = 'Wir beraten dich gerne und nehmen deine Bestellung über unsere Hotline entgegen.';
export const HotlineModalContent = ()=>/*#__PURE__*/ _jsxs("div", {
        className: styles['modal-content'],
        children: [
            /*#__PURE__*/ _jsx(Text, {
                align: "center",
                children: HOTLINE_MODAL_TITLE
            }),
            /*#__PURE__*/ _jsx(TextCTA, {
                as: "a",
                href: "tel:+494063601718",
                "data-dd-action-name": "hotline modal phone number click",
                children: "040 6360 1718"
            }),
            /*#__PURE__*/ _jsx(Text, {
                align: "center",
                bold: true,
                className: styles.text,
                size: "xs",
                children: "Montags bis freitags von 8:00 bis 18:00 Uhr."
            })
        ]
    });

//# sourceMappingURL=hotline-modal-content.js.map